<template>
  <div>
    <datatable
      title="Company Texts"
      @create="createText"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'company-texts',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'designator',
          value: 'designator'
        },
        {
          name: 'content',
          value: 'content'
        }
      ],
      data: [],
      operations: [],
      company_id: this.$route.query.company_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getResourceTexts({
          current_type: 'Company',
          current_resource_id: this.company_id
        })
        .then(response => {
          this.data = response
        })
    },
    createText () {
      this.create({ designator: 'company-texts-form-modal', component_name: 'TextsForm', is_create: true, resource_type: 'Company', resource_id: this.company_id, modal_title: 'Create new Text' })
    },
    editClick (data) {
      this.create({ designator: 'company-texts-form-modal', component_name: 'TextsForm', data, resource_type: 'Company', resource_id: this.company_id, modal_title: data.designator })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
